import React from 'react';
import { Button, Flex, Box } from '@mafc/trolly';
import { ShopNow } from '@mafc/icon';
import COLORS from 'theme/colors';

interface Props {
  ctaText: string;
  isSmallButton: boolean;
  callback: any;
  disabled: boolean;
  variant: 'primary' | 'outlined';
  showExpressIcon: boolean;
  btnHeight?: number;
  price?: string;
}

const ExpressButton: React.FC<Props> = ({
  ctaText,
  isSmallButton,
  callback,
  disabled,
  variant,
  showExpressIcon,
  btnHeight = 42,
  price = '',
}) => {
  return (
    <Button
      variant={variant}
      width={isSmallButton ? '9.2rem' : 1}
      onClick={callback}
      disabled={disabled}
      p={showExpressIcon ? 2 : 3}
      mr={showExpressIcon ? 2 : 0}
      borderRadius={2}
      height={btnHeight}
      fontWeight={5}
    >
      <Flex alignItems="center" justifyContent="center" width="100%">
        {showExpressIcon ? <ShopNow testid="ShopNow" size={'M'} fill={COLORS.BLUE} /> : null}
        <Box as="span" ml={2} width={showExpressIcon ? '' : '100%'}>
          {price !== '' ? (
            <Flex
              justifyContent={['space-between', null, null, 'space-around']}
              px={[2, null, null, 0]}
            >
              <Box as="span">{ctaText}</Box>
              <Box as="span" display={['inline', null, null, 'none']}>
                {price}
              </Box>
            </Flex>
          ) : (
            ctaText
          )}
        </Box>
      </Flex>
    </Button>
  );
};

export default ExpressButton;
